import { loadYoutubeAPI, updateQueryStringParam } from '../Utils/Utils';

const MediaLibrary = (domEl) => {

	let isLoading = false;
	let resetBeforeShowing = false;

	const timeline = domEl.querySelector('.timeline');
	const mediaLibraryTypeFilters =  domEl.querySelectorAll('.media-library-type-filter .filter');
	const loadMoreButton = domEl.querySelector('.load-more-button');
	const modal = domEl.querySelector('.modal');
	let player;

	// Data Filters
	const posts_per_page = ( parseInt( domEl.getAttribute('data-posts_per_page')) > 0 ? parseInt(domEl.getAttribute('data-posts_per_page')) : 12 );
	let paged = ( parseInt( domEl.getAttribute('data-paged')) >= 0 ? parseInt(domEl.getAttribute('data-paged')) : 1 );
	const post_types = domEl.getAttribute('data-post_types');
	let offset = parseInt(domEl.getAttribute('data-offset'));
	const orderby = domEl.getAttribute('data-orderby');
	const order = domEl.getAttribute('data-order');
	let mediaLibraryType = domEl.getAttribute('data-media-library-type');

	//
	// Filter methods
	const renderFilters = () => {
		mediaLibraryTypeFilters.forEach((filter) => {
			if(filter.getAttribute('data-slug') === mediaLibraryType) {
				filter.classList.add('js-active');
			}
			else {
				filter.classList.remove('js-active');
			}
		});
	};

	//
	// Ajax Methods
	const getBatch = () => {

		if(isLoading) {
			return false;
		}

		// Prepare to get a new batch
		domEl.classList.add('js-loading');
		isLoading = true;

		const formData = new FormData();
		formData.append('action', SVITZER21_Localize.action.getBatchMediaLibraryItems);
		formData.append('nonce', SVITZER21_Localize.nonce.getBatchMediaLibraryItems);
		formData.append('paged', paged);
		formData.append('offset', offset);
		formData.append('posts_per_page', posts_per_page);
		formData.append('post_types', post_types);
		formData.append('orderby', orderby);
		formData.append('order', order);
		if(mediaLibraryType) {
			formData.append('media-library-type', mediaLibraryType);
		}

		const header = new Headers({
			'Accept': 'application/json',
			'Content-Type': 'application/json',
		});
		fetch(SVITZER21_Localize.ajaxUrl, {
			method		: 'POST',
			mode		: 'cors',
			header		: header,
			body		: formData,
			credentials	: 'same-origin',
			cache		: 'no-store',
		})
			.then((response) => {
				if(response.status >= 200 && response.status < 300) return Promise.resolve(response);
				else return Promise.reject(new Error(response.statusText));
			})
			.then((response) => {
				return response.json();
			})
			.then( onBatchFetched )
			.catch((ex) => {
				console.log('MediaLibrary > parsing failed', ex);
				isLoading = false;
			});
	};

	const onBatchFetched = (response) => {

		if(response.success) {

			/*
			if(paged === 1) {
				window.scroll({ top: 0, left: 0, behavior: 'smooth' });
			}
			*/

			// Update the history so we can go back and forth
			if(history.pushState) {
				// The current page number
				const uri = updateQueryStringParam('pg', paged);
				window.history.pushState({path:uri},'',uri);
			}

			// Alter the timeline
			if(response.data.post_count <= 0 && paged === 1) {
				timeline.innerHTML = '';
				hideLoadMoreBtn();
			}
			else if(response.data.post_count > 0) {

				//$_no_results.style.display = 'none';

				// Append the posts to the timeline
				if(resetBeforeShowing) {
					timeline.innerHTML = '';
				}

				timeline.insertAdjacentHTML('beforeend', response.data.posts );

				// Manage the load more button
				if(response.data.found_posts > 0) {
					if((paged * posts_per_page) >= response.data.found_posts || (offset + posts_per_page) >= response.data.found_posts) {
						hideLoadMoreBtn();
					}
					else {
						showLoadMoreBtn();
					}
				}

				// Per default - the single post-media-library-item instances are hidden and only revealed via IntersectionObserverAnimation
				// We replicate that functionality
				domEl.querySelectorAll('.post-media-library-item:not(.in-view)').forEach(el => observer.observe(el));

				// Init the preview ofr new items
				initializePreviewButtons();

				// Prepare next
				paged++;
				offset += posts_per_page;
			}
			else
			{
				// No more posts to append
				if(loadMoreButton.length > 0) {
					hideLoadMoreBtn();
				}
			}

			resetBeforeShowing	= false;


			document.dispatchEvent( new CustomEvent('mediaLibraryUpdated', {
				detail: {
				}
			}) );
		}

		// Re-enable load
		isLoading = false;
		domEl.classList.remove('js-loading');
	};

	let observer = new IntersectionObserver((entries, observer) => {
		entries.forEach(entry => {
			if(entry.intersectionRatio !== 0) {
				entry.target.classList.add('in-view');
				observer.unobserve(entry.target);
			}
		});
	},
	{rootMargin: "0px 0px 0px 0px"});

	const hideLoadMoreBtn = () => {
		if(loadMoreButton) {
			loadMoreButton.style.display = 'none';
		}
	};
	const showLoadMoreBtn = () => {
		if(loadMoreButton) {
			loadMoreButton.style.display = 'flex';
		}
	};

	//
	// Preview Methods
	const initializePreviewModal = () => {
		modal.querySelector('.modal-bg').addEventListener('click', hidePreview);
		modal.querySelector('.modal-close').addEventListener('click', hidePreview);
	};
	const initializePreviewButtons = () => {
		domEl.querySelectorAll('.post-media-library-item:not(.preview-initialized) .preview-button').forEach((el) => {
			el.addEventListener('click', (e) => {
				e.preventDefault();

				// Check for cookie compliance if youtube
				if(e.currentTarget.getAttribute('data-type') === 'youtube') {

					if(window.CookieInformation && (!window.CookieInformation.getConsentGivenFor('cookie_cat_marketing') || !window.CookieInformation.getConsentGivenFor('cookie_cat_statistic'))) {
						const youtubeId = e.currentTarget.getAttribute('data-src');
						if(youtubeId.includes('http')) {
							window.open(youtubeId);
						}
						else {
							window.open(`https://www.youtube.com/watch?v=${youtubeId}`);
						}
					}
					else {
						showPreview(e.currentTarget);
					}
				}
				else {
					showPreview(e.currentTarget);
				}

			});

		});
	};
	const showPreview = (item) => {

		hidePreview();

		const type = item.getAttribute('data-type');

		const mediaArea = modal.querySelector('.modal-media');
		const contextArea = modal.querySelector('.modal-context');
		contextArea.textContent = item.getAttribute('data-context');

		if(type === 'youtube') {

			const youtubeId = item.getAttribute('data-src');

			loadYoutubeAPI(() => {

				const placeholder = document.createElement('div');
				mediaArea.appendChild(placeholder);

				const options = {
					videoId: youtubeId,
					width: '1600',
					height: '900',
					playerVars: {
						modestbranding: 1,
						playsinline: 1,
						rel: 0,
						autoplay: 1,
					},
					events: {
						//'onReady': onPlayerReady,
						'onStateChange': (e) => {
							if(e.data === YT.PlayerState.ENDED) {
								hidePreview();
							}
						}
					}
				};
				player = new YT.Player(placeholder, options);
			});
		}
		else {
			const image = new Image(800, 450);
			image.onload = () => image.classList.add('js-loaded');
			image.src = item.getAttribute('data-src');
			mediaArea.appendChild(image);
		}

		if(item.getAttribute('data-object-fit') === 'contain') {
			modal.classList.add('js-object-fit-contain');
		}
		modal.classList.add('js-revealed');

		document.body.classList.add('js-media-library-modal-revealed');
	};
	const hidePreview = (e) => {
		if(e) {
			e.preventDefault();
		}

		if(player) {
			player.stopVideo();
			player.destroy();
			player = null;
		}

		const mediaArea = modal.querySelector('.modal-media');
		mediaArea.innerHTML = '';
		const contextArea = modal.querySelector('.modal-context');
		contextArea.innerHTML = '';

		modal.classList.remove('js-revealed');
		modal.classList.remove('js-object-fit-contain');

		document.body.classList.remove('js-media-library-modal-revealed');
	};

	//
	// Copy to Clipboard methods
	const initializeCopyToClipboard = () => {
		domEl.querySelectorAll('.post-media-library-item .copy-url:not(.copy-url-initialized)').forEach((btn) => {
			btn.addEventListener('click', (e) => {
				e.preventDefault();

				let url = btn.getAttribute('data-url')
				if(!url.includes('http')) {
					url = `https://${url}`;
				}

				const el = document.createElement('textarea');
				el.value = url;
				el.setAttribute('readonly', '');
				el.style.position = 'absolute';
				el.style.left = '-9999px';
				document.body.appendChild(el);
				el.select();
				document.execCommand('copy');
				document.body.removeChild(el);


				if(btn.getAttribute('data-tooltip-backup')) {
					btn.setAttribute('data-tooltip', btn.getAttribute('data-tooltip-backup'));
				}
				btn.setAttribute('data-tooltip-backup', btn.getAttribute('data-tooltip'));
				btn.setAttribute('data-tooltip', 'Copied');

				setTimeout(() => {
					btn.setAttribute('data-tooltip', btn.getAttribute('data-tooltip-backup'));
				}, 2000);
			});
		});
	};

	//
	// Initialize
	initializePreviewModal();
	initializePreviewButtons();

	loadMoreButton.addEventListener('click', (e) => {
		e.preventDefault();
		if(!isLoading) {
			getBatch();
		}
	});

	mediaLibraryTypeFilters.forEach((filter) => {
		filter.addEventListener('click', (e) => {
			e.preventDefault();

			// Get the Media Library Type slug
			const slug = filter.getAttribute('data-slug');
			if(slug !== mediaLibraryType) {
				mediaLibraryType = slug;

				// Update the history so we can go back and forth
				if(history.pushState) {
					// The current page number
					const uri = updateQueryStringParam('media-library-type', slug);
					window.history.pushState({path:uri},'',uri);
				}

				resetBeforeShowing = true;
				paged = 1;
				offset = 0;
				//isLoading = false;
				getBatch();
				renderFilters();
			}
		});
	});

	// Listen to changes in history when using back/forth buttons
	// Update the Media Library Type and fetch data
	window.addEventListener('popstate', function (e) {
		const urlParams = new URLSearchParams(window.location.search);
		if(urlParams.get('media-library-type') !== mediaLibraryType) {
			mediaLibraryType = urlParams.get('media-library-type');
			resetBeforeShowing = true;
			paged = 1;
			offset = 0;
			//isLoading = false;
			getBatch();
			renderFilters();
		}
		hidePreview();
	});

	/**
	// Setup infinite scroll. DEPRECATED
	let observerInfiniteScroll = new IntersectionObserver((entries, observer) => {
			entries.forEach(entry => {
				if(entry.intersectionRatio !== 0) {
					getBatch();
				}
			});
		},
		{rootMargin: "0px 0px 300px 0px"});
	observerInfiniteScroll.observe(loadMoreButton);
	*/
};

export default MediaLibrary;